<template>
    <div class="bug-table" ref="export">
        <a-table :pagination="false" :data-source="formState.tableData" :columns="columns" :customRow="customRow" bordered>
        </a-table>
    </div>
    <div class="bug-btn">
        <a-button type="primary" @click="$confirm(target, formState)">保存</a-button>
        <a-dropdown>
            <template #overlay>
                <a-menu @click="exportFile">
                    <a-menu-item key="pdf">
                        PDF
                    </a-menu-item>
                    <a-menu-item key="img">
                        图片
                    </a-menu-item>
                </a-menu>
            </template>
            <a-button type="primary">导出<DownOutlined /></a-button>
        </a-dropdown>
        <a
            style="display: none"
            ref="btn"
            :href="picURL"
            :download="fileName + '.jpeg'"
        ></a>
    </div>
    <rightMenu :menu="menu" @add="addRow" @up="upRow" @down="downRow" @del="delRow" @cancel='menu.show = false' />
</template>
<script>
import { h } from "vue";
import { Input } from "ant-design-vue";
import { DownOutlined } from '@ant-design/icons-vue';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import rightMenu from '@/components/rightMenu'

export default {
    components: {
        DownOutlined,
        rightMenu
    },
    data() {
        return {
            target: null,
            targetName: "bug",
            picURL: '',
            defaultState: {},
            menu: {
                show: false,
                x: 0,
                y: 0,
            },
            formState: {
                pid: "",
                num: "",
                tableData: [
                    ['一、项目基本信息'],
                    ['项目名称', ''],
                    ['反馈编号', ''],
                    ['实施方负责人', '', '委托方负责人', ''],
                    ['反馈方式', '', '反馈日期', ''],
                    ['二、反馈详情'],
                    ['功能', '正确表现', '异常表现', '处理优先级'],
                    ['右键更多操作'],
                    ['处理时效', ''],
                    ['三、签字确认'],
                    ['委托方负责人', '', '实施方负责人', ''],
                ]
            },
            editKey: {},
            columns: [{
                    dataIndex: 0,
                    title: '缺陷反馈表',
                    colSpan: 4,
                    width: 200,
                    customRender: this.customRender(0),
                },
                {
                    dataIndex: 1,
                    colSpan: 0,
                    customRender: this.customRender(1),
                },
                {
                    dataIndex: 2,
                    colSpan: 0,
                    width: 200,
                    customRender: this.customRender(2),
                },
                {
                    dataIndex: 3,
                    colSpan: 0,
                    width: 200,
                    customRender: this.customRender(3),
                },
            ]
        };
    },
    async mounted() {
        window.t = this
        this.formState.pid = this.$route.query.pid
        this.tableDataBackup = JSON.parse(JSON.stringify(this.tableData))
        // 后面通过是否存在初始值判断是否为标题且是否可以编辑
        this.tableDataBackup[7][0] = ''

        this.$loadDetail()
    },
    watch: {
        'formState.tableData': {
            deep: true,
            immediate: true,
            async handler() {
                this.formState.num = this.tableData[2][1]

                await this.$nextTick();
                // 清空斑马线
                let $stripe = document.querySelectorAll(".stripe");
                $stripe.forEach(i => {
                    i.classList.remove("stripe");
                });
                // 处理斑马线背景色
                [0, 5, this.dataCount-2].forEach(idx => {
                    document.querySelectorAll(`tr[data-row-key="${idx}"] td`).forEach(i => {
                        i.classList.add("stripe")
                    })
                })
            }
        }
    },
    computed: {
        tableData: { 
            get() {
                return this.formState.tableData
            },
            set(v) {
                this.formState.tableData = v
            }
        },
        dataCount() {
            return this.formState.tableData.length
        },
        fileName() {
            return `${this.tableData[1][1]} - ${this.tableData[2][1]}`
        }
    },
    methods: {
        async exportFile({ key }) {
            await this.$nextTick();
            let dom = this.$refs.export;
            let { offsetWidth: width, offsetHeight: height } = dom

            let canvas = await html2canvas(dom, {
              width, //dom 原始宽度
              height,
              scale: 2,
            })

            if (key == 'pdf') {
                const doc = new jsPDF({
                    unit: 'px',
                    format: [width, height],
                    compress: true,
                });
                doc.addImage(canvas.toDataURL("image/jpeg"), 'jpeg', 0, 0, width, height)
                doc.save(this.fileName + '.pdf')
            }

            if (key == 'img') {
                this.picURL = canvas.toDataURL("image/jpeg")
                await this.$nextTick();
                await this.$refs.btn.click();
            }
        },
        getDataset(e) {
            let { row, col } = e.target.dataset;
            row = parseInt(row);
            col = parseInt(col);
            return { row, col };
        },
        customRow() {
            return {
                // 单击
                onClick: async (e) => {
                    // console.log(record, index, event);
                    let { row, col } = this.getDataset(e);

                    if (row <= 6 && this.tableDataBackup[row][col])
                        return this.$message.warn('不可编辑')
                    let inverse = this.dataCount - row
                    if (inverse <= 3 && this.tableDataBackup[this.tableDataBackup.length-inverse][col])
                        return this.$message.warn('不可编辑')
                    this.editKey[`${row}_${col}`] = 1;

                    await this.$nextTick();
                    let $textarea = e.currentTarget.querySelector("textarea")
                    $textarea.focus();
                    $textarea.select();
                },
                // 右键菜单
                onContextmenu: (e) => {
                    let { row, col } = this.getDataset(e);
                    if (isNaN(row)) return
                    if (row <= 6) return
                    if (this.dataCount - row <= 3) return
                    e.preventDefault();

                    this.menu.show = true;
                    this.menu.x = e.clientX;
                    this.menu.y = e.clientY;
                    this.menu.row = row;
                    this.menu.col = col;
                    this.menu.target = this.tableData[row];
                },
            }
        },
        customRender(col) {
            let _col = col
            return ({ text, index: row }, col = _col) => {
            // return ({ text, record, index: row }, col = _col) => {
                const obj = {
                    children: (() => {
                        if (this.editKey[`${row}_${col}`]) {
                            let autosize = "autosize";
                                // autosize = { minRows: 9, maxRows: 9 };

                            return h(Input.TextArea, {
                                autosize,
                                value: this.tableData[row][col],
                                style: {
                                    padding: '2px',
                                    lineHeight: '32px',
                                    textAlign: 'center', // 居中编辑
                                },
                                "onUpdate:value": (value) =>
                                    (this.tableData[row][col] = value),
                                onBlur: () => delete this.editKey[`${row}_${col}`],
                            });
                        }
                        if (text) return text
                        return h('span', {
                            style: {
                                height: '17px',
                                display: 'inline-block',
                                fontWeight: 'blod'
                            }
                        }, text);
                    })(),
                    props: {
                        align: 'center',
                        "data-row": row,
                        "data-col": col,
                    }
                }

                if (row == 0 || row == 5 || row == this.dataCount - 2) {
                    obj.props.colSpan = 0;
                    if (col == 0) {
                        obj.props.colSpan = 4;
                        obj.props.align = 'left';
                    }
                }
                if (row == 1 || row == 2 || row == this.dataCount - 3) {
                    obj.props.colSpan = 0;
                    if (col == 0) {
                        obj.props.colSpan = 1;
                    }
                    if (col == 1) {
                        obj.props.colSpan = 3;
                    }
                }
                return obj
            }
        },

        addRow() {
            this.tableData.splice(this.menu.row+1, 0, [])
        },

        delRow() {
            if (this.dataCount == 11) return this.$message.warn('至少需要保留一条变更')
            this.tableData = this.tableData.filter((i, idx) => {
                return idx != this.menu.row
            })
        },

        upRow() {
            if (this.menu.row == 7) return this.$message.warn('已经到头')
            let target = this.tableData[this.menu.row]
            this.tableData[this.menu.row] = this.tableData[this.menu.row - 1]
            this.tableData[this.menu.row - 1] = target
        },

        downRow() {
            if (this.menu.row == this.dataCount - 4) return this.$message.warn('已经到头')
            let target = this.tableData[this.menu.row]
            this.tableData[this.menu.row] = this.tableData[this.menu.row + 1]
            this.tableData[this.menu.row + 1] = target
        },
    },
};
</script>
<style lang="scss">
.bug-table .ant-table-body {
    .ant-table-tbody {
        td {
            line-height: 32px;
            white-space: pre-wrap;
        }
    }

    .ant-table-thead {
        th {
            font-weight: 300;
            font-size: 22px;
        }
    }

    th {
        color: #fff;
        background: #287fef;
        border-bottom: 3px solid #216ac8;
        font-size: 14px;
        font-weight: 700;

        p {
            margin: 0;
        }
    }
}
.stripe {
  background: #f7fafe;
  font-size: 15px
}
</style>
<style scoped lang="scss">
.bug-table {
    width: 800px;
    margin: 0 auto;
}
.bug-btn {
    text-align: center;
    > * {
      margin: 80px 30px;
    }
}
</style>
